import { c as _c } from "react/compiler-runtime";
import Link from 'next/link';
import type { ScopeOfWork_KeyResult } from '@/modules/__generated__/graphql/switchboard-generated';
import { CopyAnimatedIcon, CopyButton, CopyTrigger } from '@/modules/shared/components/copy-button';
import { KeyResultModal } from './key-result-modal';
import type { Route } from 'next';
interface KeyResultItemProps {
  keyResult: ScopeOfWork_KeyResult;
}
function KeyResultItem(t0) {
  const $ = _c(9);
  const {
    keyResult
  } = t0;
  const hasLink = Boolean(keyResult.link && keyResult.link !== "");
  let t1;
  if ($[0] !== hasLink || $[1] !== keyResult) {
    t1 = hasLink ? <Link href={keyResult.link as Route} target="_blank" className="flex items-center gap-1"><KeyResultModal keyResult={keyResult} /></Link> : <div className="flex items-center gap-1"><KeyResultModal keyResult={keyResult} /></div>;
    $[0] = hasLink;
    $[1] = keyResult;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== hasLink || $[4] !== keyResult.link) {
    t2 = hasLink && <div className="flex items-center gap-2 sm:w-30 md:w-48 lg:w-64"><span className="text-muted-foreground w-full truncate text-end text-sm">{keyResult.link}</span><CopyButton value={keyResult.link}><CopyTrigger><CopyAnimatedIcon className="size-4" /></CopyTrigger></CopyButton></div>;
    $[3] = hasLink;
    $[4] = keyResult.link;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[6] !== t1 || $[7] !== t2) {
    t3 = <li className="border-muted mb-0! flex flex-wrap items-center justify-between gap-x-2 border-b px-2 pb-2 last:border-b-0 sm:flex-nowrap sm:gap-2">{t1}{t2}</li>;
    $[6] = t1;
    $[7] = t2;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  return t3;
}
export { KeyResultItem };